'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopupHeader = function PopupHeader(props) {

  var styles = require('./PopupBoxWithBackground.scss');

  return _react2.default.createElement(
    'div',
    { className: styles.PopupHeader },
    _react2.default.createElement(_components.TextButton, {
      small: true,
      label: '< Back',
      onClick: function onClick() {
        props.forceClose();
      }
    })
  );
};

var PopupBoxWithBackground = function (_React$Component) {
  (0, _inherits3.default)(PopupBoxWithBackground, _React$Component);

  function PopupBoxWithBackground() {
    (0, _classCallCheck3.default)(this, PopupBoxWithBackground);
    return (0, _possibleConstructorReturn3.default)(this, (PopupBoxWithBackground.__proto__ || (0, _getPrototypeOf2.default)(PopupBoxWithBackground)).apply(this, arguments));
  }

  (0, _createClass3.default)(PopupBoxWithBackground, [{
    key: 'render',
    value: function render() {
      var styles = require('./PopupBoxWithBackground.scss');

      var classes = styles['PopupBox'];
      classes = classes.concat(" " + (this.props.className || ""));

      return _react2.default.createElement(
        _components.AppSideEffects,
        { scrollTop: 0 },
        _react2.default.createElement(
          'div',
          { className: classes, style: { backgroundImage: 'url(\'' + this.props.image + '\')' } },
          _react2.default.createElement(PopupHeader, { forceClose: this.props.forceClose }),
          _react2.default.createElement(
            'div',
            { className: styles['PopupBox__inner'] },
            this.props.children
          )
        )
      );
    }
  }]);
  return PopupBoxWithBackground;
}(_react2.default.Component);

exports.default = PopupBoxWithBackground;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PopupBoxWithBackground/PopupBoxWithBackground.jsx
// module id = 2685
// module chunks = 0